import { put } from 'redux-saga/effects';
import EasyRedux from '../../utils/EasyRedux';
import handleSagaError from '../handleSagaError';
import history from '../../utils/history';

const key = 'AUTH/KNOCK';

export const { actionTypes, actions, reducer } = new EasyRedux(key);

export function* watchKnock(client, { payload: { mobile } }) {
  try {
    const newMobile = mobile.replace(0, 98);
    const response = yield client.post('/user/auth/knock', {
      data: { mb: newMobile },
    });
    yield put(actions.loadSuccess(response.result));
    yield history.push('/auth/verify');
  } catch (e) {
    yield put(actions.loadFailure(e));
    yield handleSagaError(e);
  }
}

export default reducer;
